import React, { useEffect, useRef } from 'react';
import * as THREE from 'three';
import './App.css';
import MonitorControlUI from './MonitorControlUI';

const App = () => {
  const mountRef = useRef(null);

  useEffect(() => {
    const mount = mountRef.current;
    if (!mount) return undefined;

    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(
      60,
      window.innerWidth / window.innerHeight,
      0.1,
      1000
    );
    camera.position.z = 18;

    const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 1.6));
    renderer.setSize(window.innerWidth, window.innerHeight);
    renderer.setClearColor(0x07111f, 1);
    mount.appendChild(renderer.domElement);

    const starCount = 900;
    const starGeometry = new THREE.BufferGeometry();
    const positions = new Float32Array(starCount * 3);
    const scales = new Float32Array(starCount);

    for (let i = 0; i < starCount; i += 1) {
      const index = i * 3;
      positions[index] = (Math.random() - 0.5) * 80;
      positions[index + 1] = (Math.random() - 0.5) * 80;
      positions[index + 2] = (Math.random() - 0.5) * 80;
      scales[i] = 0.5 + Math.random() * 1.4;
    }

    starGeometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));
    starGeometry.setAttribute('aScale', new THREE.BufferAttribute(scales, 1));

    const starMaterial = new THREE.PointsMaterial({
      color: 0xf8fafc,
      size: 0.16,
      transparent: true,
      opacity: 0.9,
      blending: THREE.AdditiveBlending
    });

    const stars = new THREE.Points(starGeometry, starMaterial);
    scene.add(stars);

    const clock = new THREE.Clock();
    let frameId;

    const animate = () => {
      frameId = window.requestAnimationFrame(animate);
      const elapsed = clock.getElapsedTime();
      stars.rotation.y = elapsed * 0.03;
      stars.rotation.x = Math.sin(elapsed * 0.08) * 0.08;

      const starPositions = starGeometry.attributes.position.array;
      for (let i = 0; i < starPositions.length; i += 3) {
        starPositions[i + 2] += 0.03;
        if (starPositions[i + 2] > 38) {
          starPositions[i + 2] = -38;
        }
      }
      starGeometry.attributes.position.needsUpdate = true;
      renderer.render(scene, camera);
    };

    const handleResize = () => {
      camera.aspect = window.innerWidth / window.innerHeight;
      camera.updateProjectionMatrix();
      renderer.setSize(window.innerWidth, window.innerHeight);
    };

    animate();
    window.addEventListener('resize', handleResize);

    return () => {
      window.cancelAnimationFrame(frameId);
      window.removeEventListener('resize', handleResize);
      starGeometry.dispose();
      starMaterial.dispose();
      renderer.dispose();
      if (mount.contains(renderer.domElement)) {
        mount.removeChild(renderer.domElement);
      }
    };
  }, []);

  return (
    <div className="app-shell">
      <div className="background-galaxy" ref={mountRef} aria-hidden="true" />
      <div className="background-glow background-glow-one" aria-hidden="true" />
      <div className="background-glow background-glow-two" aria-hidden="true" />
      <main className="app-stage">
        <MonitorControlUI />
      </main>
    </div>
  );
};

export default App;
